import React, { useState } from "react";
import { HashLink } from "react-router-hash-link";
import Carousel from "react-multi-carousel";

import "react-multi-carousel/lib/styles.css";
import "./Home.css";

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
    slidesToSlide: 3, // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 4, // optional, default to 1.
  },
};

const Home = () => {
  const [navDropDownBtn, setNavDropDownBtn] = useState(false);

  const handleNavDropDownBtn = () => setNavDropDownBtn(!navDropDownBtn);

  const [homeDropDownBtn, setHomeDropDownBtn] = useState(false);

  const handleHomeDropDownBtn = () => setHomeDropDownBtn(!homeDropDownBtn);

  return (
    <>
      <nav className="mobile-nav">
        <div className="mobile-nav-container">
          <div className="mobile-nav-logo-container">
            <HashLink smooth to="/#home">
              <img
                src="/assets/navlogo.png"
                alt="mobile-nav-logo"
                className="mobile-nav-logo"
              />
            </HashLink>
            <button
              className={
                navDropDownBtn
                  ? "mobile-nav-toggle active"
                  : "mobile-nav-toggle"
              }
              onClick={handleNavDropDownBtn}
            >
              <i class="fa-solid fa-bars"></i>
            </button>
          </div>
          <div
            className={
              navDropDownBtn
                ? "mobile-nav-menu-container active"
                : "mobile-nav-menu-container"
            }
          >
            <ul className="mobile-nav-menu">
              <li
                className="mobile-nav-item"
                onClick={() => setNavDropDownBtn(false)}
              >
                <HashLink smooth to="/#about-us" className="mobile-nav-link">
                  ABOUT US
                </HashLink>
              </li>
              <li
                className="mobile-nav-item"
                onClick={() => setNavDropDownBtn(false)}
              >
                <HashLink
                  smooth
                  to="/#services"
                  className="mobile-nav-link"
                  onClick={() => setHomeDropDownBtn(true)}
                >
                  SERVICES
                </HashLink>
              </li>
              <li
                className="mobile-nav-item"
                onClick={() => setNavDropDownBtn(false)}
              >
                <HashLink
                  smooth
                  to="/projects/#projects"
                  className="mobile-nav-link"
                >
                  PROJECTS
                </HashLink>
              </li>
              <li
                className="mobile-nav-item"
                onClick={() => setNavDropDownBtn(false)}
              >
                <HashLink smooth to="/#contact-us" className="mobile-nav-link">
                  CONTACT US
                </HashLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <nav className="navbar">
        <div className="nav-container">
          <div className="navbar__logo__container">
            <HashLink smooth to="/#home">
              <img
                src="/assets/navlogo.png"
                alt="nav-logo"
                className="navbar__logo"
              />
            </HashLink>
          </div>
          <div className="navbar__menu__container">
            <ul className="navbar__menu">
              <li className="navbar__item">
                <HashLink
                  smooth
                  to="/#about-us"
                  className="navbar__link active"
                >
                  ABOUT US
                </HashLink>
              </li>
              <li className="navbar__item">
                <HashLink
                  smooth
                  to="/#services"
                  className="navbar__link"
                  onClick={() => setHomeDropDownBtn(true)}
                >
                  SERVICES
                </HashLink>
              </li>
              <li className="navbar__item">
                <HashLink
                  smooth
                  to="/projects/#projects"
                  className="navbar__link"
                >
                  PROJECTS
                </HashLink>
              </li>
              <li className="navbar__item">
                <HashLink smooth to="/#contact-us" className="navbar__link">
                  CONTACT US
                </HashLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <div id="home" className="home">
        <div className="home-container">
          <section className="home__mainbg__container">
            <img
              src="/assets/mainlogo.png"
              alt="nav-logo"
              className="home__mainbg"
            />
          </section>
          <section id="about-us" className="aboutus-container">
            <div className="aboutus-title">ABOUT US</div>
            <div className="aboutus-content">
              <span>
                Floodwey Construction Company Limited is a duly registered
                property development company defining and developing exceptional
                luxury living spaces which cover various lifestyles with the
                highest quality standards. We pride ourselves in ensuring our
                buildings are structurally engineered to meet all building
                standards, safety codes and requirements to the letter by
                engaging series of competent and experienced consultants and
                contractors.
                <br />
                Floodwey Construction is a dynamic firm dedicated to shaping
                Nigeria’s landscape through innovative real estate solutions and
                exceptional construction services. We specialize in a broad
                range of services including residential and commercial real
                estate, as well as comprehensive construction solutions.
              </span>
            </div>
          </section>
          <button
            className={
              homeDropDownBtn
                ? "home-content-toggle active"
                : "home-content-toggle"
            }
            onClick={handleHomeDropDownBtn}
          >
            <i class="fa-solid fa-arrow-down"></i> Click for more Information
          </button>
          <div
            className={
              homeDropDownBtn
                ? "home-content-container active"
                : "home-content-container"
            }
          >
            <ul className="home-content">
              <li className="mission-container">
                <div className="mission-title">MISSION</div>
                <div className="mission-content">
                  <span>
                    Our mission is to redefine the real estate and construction
                    experience in Nigeria by providing exceptional service,
                    high-quality construction, and innovative solutions. We are
                    committed to enhancing communities and creating lasting
                    value through our projects.
                  </span>
                </div>
              </li>
              <li
                style={{
                  backgroundColor: "#F5F7FF",
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div className="core-values-title">CORE VALUES</div>
                <div
                  className="core-values-content"
                  style={{ textAlign: "left" }}
                >
                  <ul
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "15px",
                    }}
                  >
                    <li>
                      <span>
                        <span
                          style={{
                            fontFamily: "sans-serif",
                            color: "black",
                            fontWeight: "900",
                          }}
                        >
                          Integrity:
                        </span>{" "}
                        We uphold the highest standards of honesty and
                        transparency in all our dealings and projects.
                      </span>
                    </li>
                    <li>
                      <span>
                        <span
                          style={{
                            fontFamily: "sans-serif",
                            color: "black",
                            fontWeight: "900",
                          }}
                        >
                          Customer-Centricity:
                        </span>{" "}
                        We prioritize our clients’ needs, offering personalized
                        solutions and exceptional service to ensure their
                        satisfaction.
                      </span>
                    </li>
                    <li>
                      <span>
                        <span
                          style={{
                            fontFamily: "sans-serif",
                            color: "black",
                            fontWeight: "900",
                          }}
                        >
                          Innovation:{" "}
                        </span>
                        We embrace innovative practices and cutting-edge
                        technology to enhance our services and deliver superior
                        results.
                      </span>
                    </li>
                    <li>
                      <span>
                        <span
                          style={{
                            fontFamily: "sans-serif",
                            color: "black",
                            fontWeight: "900",
                          }}
                        >
                          Excellence:{" "}
                        </span>
                        We are committed to excellence in every aspect of our
                        work, from construction quality to client service.
                      </span>
                    </li>
                  </ul>
                </div>
              </li>
              <li
                id="services"
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div className="home-services-title">SERVICES</div>
                <div className="home-services-content">
                  <div className="col-6">
                    <span
                      style={{
                        fontFamily: "sans-serif",
                        color: "black",
                        fontWeight: "900",
                      }}
                    >
                      Real Estate Development
                    </span>
                    <p>
                      We develop residential, and commercial properties,
                      delivering <br />
                      projects that meet the highest standards of quality and
                      design
                    </p>
                    <span
                      style={{
                        fontFamily: "sans-serif",
                        color: "black",
                        fontWeight: "900",
                      }}
                    >
                      Construction Services
                    </span>
                    <p>
                      From concept to completion, we offer comprehensive <br />
                      construction services including project management,
                      design-
                      <br />
                      build, renovation, and property maintenance. We also
                      handle
                      <br />
                      civil works, including nut not limited to road
                      construction,
                      <br />
                      central sewages systems, etc.
                    </p>
                  </div>
                  <div className="col-6">
                    <div className="ourservices-img">
                      <img src="/assets/Group 10.png" alt="1" />
                    </div>
                  </div>
                </div>
                <div className="home-services-content">
                  <div className="col-6">
                    <div className="ourservices-img">
                      <img src="/assets/Group 5.png" alt="1" />
                    </div>
                  </div>
                  <div className="col-6">
                    <span
                      style={{
                        fontFamily: "sans-serif",
                        color: "black",
                        fontWeight: "900",
                      }}
                    >
                      Residential Sales & Leasing
                    </span>
                    <p>
                      Our team offers a diverse portfolio of residential
                      properties,
                      <br />
                      including apartments, houses, and estates, tailored to
                      meet
                      <br />
                      varying client needs and preferences.
                    </p>
                    <span
                      style={{
                        fontFamily: "sans-serif",
                        color: "black",
                        fontWeight: "900",
                      }}
                    >
                      Commercial Real Estate
                    </span>
                    <p>
                      We provide expert services in leasing, and managing
                      commercial
                      <br />
                      spaces, including office buildings, retail outlets, and
                      industrial
                      <br />
                      properties.
                    </p>
                  </div>
                </div>
                <div className="home-services-content">
                  <div className="col-6">
                    <span
                      style={{
                        fontFamily: "sans-serif",
                        color: "black",
                        fontWeight: "900",
                      }}
                    >
                      Property Management
                    </span>
                    <p>
                      Our property management services ensure that properties
                      are
                      <br />
                      well-maintained, tenant relations are effectively managed,
                      and
                      <br />
                      investments are optimized.
                    </p>
                    <span
                      style={{
                        fontFamily: "sans-serif",
                        color: "black",
                        fontWeight: "900",
                      }}
                    >
                      Consulting & Advisory
                    </span>
                    <p>
                      We offer strategic consulting and advisory services for
                      real estate
                      <br />
                      investments, development projects, and construction
                      planning.
                    </p>
                  </div>
                  <div className="col-6">
                    <div className="ourservices-img">
                      <img src="/assets/Group 6.png" alt="1" />
                    </div>
                  </div>
                </div>
                <div className="mobile-home-services-content">
                  <div className="col-6">
                    <span
                      style={{
                        fontFamily: "sans-serif",
                        color: "black",
                        fontWeight: "900",
                        width: "100%",
                      }}
                    >
                      Real Estate Development
                    </span>
                    <p>
                      We develop residential, and commercial properties,
                      delivering projects that meet the highest standards of
                      quality and design
                    </p>
                    <span
                      style={{
                        fontFamily: "sans-serif",
                        color: "black",
                        fontWeight: "900",
                      }}
                    >
                      Construction Services
                    </span>
                    <p>
                      From concept to completion, we offer comprehensive
                      construction services including project management,
                      design- build, renovation, and property maintenance. We
                      also handle civil works, including and not limited to road
                      construction, central sewages systems, etc.
                    </p>
                  </div>
                  <div className="col-6">
                    <div className="mobile-ourservices-img">
                      <img src="/assets/Group 23.png" alt="1" />
                    </div>
                  </div>
                </div>
                <div className="mobile-home-services-content">
                  <div className="col-6">
                    <div className="mobile-ourservices-img">
                      <img src="/assets/Group 24.png" alt="1" />
                    </div>
                  </div>
                  <div className="col-6">
                    <span
                      style={{
                        fontFamily: "sans-serif",
                        color: "black",
                        fontWeight: "900",
                      }}
                    >
                      Residential Sales & Leasing
                    </span>
                    <p>
                      Our team offers a diverse portfolio of residential
                      properties, including apartments, houses, and estates,
                      tailored to meet varying client needs and preferences.
                    </p>
                    <span
                      style={{
                        fontFamily: "sans-serif",
                        color: "black",
                        fontWeight: "900",
                      }}
                    >
                      Commercial Real Estate
                    </span>
                    <p>
                      We provide expert services in leasing, and managing
                      commercial spaces, including office buildings, retail
                      outlets, and industrial properties.
                    </p>
                  </div>
                </div>
                <div className="mobile-home-services-content">
                  <div className="col-6">
                    <span
                      style={{
                        fontFamily: "sans-serif",
                        color: "black",
                        fontWeight: "900",
                      }}
                    >
                      Property Management
                    </span>
                    <p>
                      Our property management services ensure that properties
                      are well-maintained, tenant relations are effectively
                      managed, and investments are optimized.
                    </p>
                    <span
                      style={{
                        fontFamily: "sans-serif",
                        color: "black",
                        fontWeight: "900",
                      }}
                    >
                      Consulting & Advisory
                    </span>
                    <p>
                      We offer strategic consulting and advisory services for
                      real estate investments, development projects, and
                      construction planning.
                    </p>
                  </div>
                  <div className="col-6">
                    <div className="mobile-ourservices-img">
                      <img src="/assets/Group 26.png" alt="1" />
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <section
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyItems: "flex-end",
              alignItems: "flex-end",
            }}
          >
            <div className="ourproject-container">
              <div className="ourproject-title">OUR PROJECTS</div>
              <Carousel
                className="ourproject-carousel"
                swipeable={true}
                draggable={true}
                showDots={false}
                responsive={responsive}
                ssr={true} // means to render carousel on server-side.
                infinite={false}
                autoPlaySpeed={1000}
                keyBoardControl={true}
                customTransition="all 0.5s ease-in-out"
                transitionDuration={1000}
                containerClass="carousel-container"
                dotListClass="custom-dot-list-style"
                itemClass="carousel-item-padding-40-px"
              >
                <div className="home-projects">
                  <HashLink smooth to="/projects/#one" className="navbar__link">
                    <img
                      className="home-projects-img"
                      src="/assets/Group 7.png"
                      alt="1"
                    />
                  </HashLink>
                </div>
                <div className="home-projects">
                  <HashLink smooth to="/projects/#two" className="navbar__link">
                    <img
                      className="home-projects-img"
                      src="/assets/Group 14.png"
                      alt="2"
                    />
                  </HashLink>
                </div>
                <div className="home-projects">
                  <HashLink
                    smooth
                    to="/projects/#four"
                    className="navbar__link"
                  >
                    <img
                      className="home-projects-img"
                      src="/assets/Group 15.png"
                      alt="3"
                    />
                  </HashLink>
                </div>
                <div className="home-projects">
                  <HashLink
                    smooth
                    to="/projects/#three"
                    className="navbar__link"
                  >
                    <img
                      className="home-projects-img"
                      src="/assets/Group 12.png"
                      alt="4"
                    />
                  </HashLink>
                </div>
              </Carousel>
            </div>
          </section>
        </div>
      </div>
      <nav className="footer-navbar">
        <div className="nav-container">
          <div className="footer-navbar__logo__container">
            <HashLink smooth to="/#home">
              <img
                src="/assets/navlogo.png"
                alt="nav-logo"
                className="footer-navbar__logo"
              />
            </HashLink>
          </div>
          <div className="footer-navbar__menu__container">
            <ul className="footer-navbar__menu">
              <li className="footer-navbar__item">
                <HashLink
                  smooth
                  to="/#about-us"
                  className="footer-navbar__link"
                >
                  ABOUT US
                </HashLink>
              </li>
              <li className="footer-navbar__item">
                <HashLink
                  smooth
                  to="/#services"
                  className="footer-navbar__link"
                >
                  SERVICES
                </HashLink>
              </li>
              <li className="footer-navbar__item">
                <HashLink
                  smooth
                  to="/projects/#projects"
                  className="footer-navbar__link"
                >
                  PROJECTS
                </HashLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <footer id="contact-us" className="footer">
        <div className="footer-container">
          <div className="address">
            <p>
              H-215, Ikota Shopping Complex, VGC, Lekki–Epe Expressway,
              Lagos-Nigeria.
            </p>
            <p>Tel: +234 803 191 2318 | +234 805 768 3538</p>
            <p>floodweyconstruction@gmail.com</p>
          </div>
          <div className="copyright-container">
            <div className="copyright">
              <p>
                &copy;2026, FLOODWEY CONSTRUCTION COMPANY LTD. ALL RIGHTS
                RESERVED.
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Home;
